/**
 * The version guard of a contract save (Monthly Calculator).
 *
 * The calculator edits the month rows it opened with and Save writes the whole array back. If the
 * engine's Fill from Ejar (or another user) saved the contract meanwhile, writing the older rows
 * would silently undo that work (26 Sep 2026 audit, CON-03). Every writer stamps `last_updated`
 * (ISO text: this app's updateContract and the engine's save_fill / rent learning), so a save that
 * carries the stamp it opened with is refused when the document's stamp is different now.
 */

export const CONTRACT_CHANGED = 'contract-changed';

const stampOf = (v) => {
    if (v == null) return '';
    if (typeof v.toDate === 'function') return v.toDate().toISOString();   // a Firestore Timestamp
    return String(v);
};

/** True when the document was written after the copy stamped `expected` was read. */
export const contractChangedSince = (currentData, expected) =>
    stampOf(currentData && currentData.last_updated) !== stampOf(expected);

/** The Error a refused save throws: code CONTRACT_CHANGED and a message the user can act on. */
export const contractChangedError = (currentData) => {
    const who = currentData && currentData.updated_by
        ? `${currentData.updated_by}${currentData.update_source ? ` (${currentData.update_source})` : ''}`
        : 'someone else';
    const at = stampOf(currentData && currentData.last_updated);
    const when = at ? ` at ${at.slice(0, 16).replace('T', ' ')} UTC` : '';
    const err = new Error(`This contract was changed by ${who}${when} after you opened it. Nothing was saved - close the calculator and open it again to see the latest months, then redo your change.`);
    err.code = CONTRACT_CHANGED;
    return err;
};
